import initialState from './initialState';
import { reducer as fetchItemDetailsReducer } from './fetchItemDetails';
import { reducer as fetchShipToDetailsReducer } from './fetchShipToDetails';
import { reducer as fetchSiteInfoReducer } from './fetchSiteInfo';
import { reducer as resetItemDetailsReducer } from './resetItemDetails';
import { reducer as resetShipToDetailsReducer } from './resetShipToDetails';

const reducers = [
  fetchItemDetailsReducer,
  fetchShipToDetailsReducer,
  fetchSiteInfoReducer,
   resetItemDetailsReducer,
  resetShipToDetailsReducer,
];

export default function reducer(state = initialState, action) {
  let newState;
  switch (action.type) {
    default:
      newState = state;
      break;
  }
  return reducers.reduce((s, r) => r(s, action), newState);
}


